import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../lib/api";

// Valeurs neutres utilisées seulement si le serveur ne répond pas.
const FALLBACK = {
  name: "Commande en ligne",
  tagline: "",
  footer_tagline: "",
  logo_url: "",
  website: "",
  contact_email: "",
  primary: null,
  primary_foreground: null,
  secondary: null,
  sauces: ["Blanche", "Rouge", "Gold"],
  public_catalog: false,
};

const BrandContext = createContext(FALLBACK);

export const useBrand = () => useContext(BrandContext);

export const brandSlug = (name) =>
  (name || "commande").toLowerCase().normalize("NFD").replace(/[̀-ͯ]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

/**
 * Charge l'identité de l'installation (nom, logo, couleurs, sauces) depuis /api/brand.
 * Une même version du site sert ainsi plusieurs marques : tout vient de la configuration du serveur.
 */
export const BrandProvider = ({ children }) => {
  const [brand, setBrand] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.get("/brand")
      .then((r) => { if (!cancelled) setBrand({ ...FALLBACK, ...r.data }); })
      .catch(() => { if (!cancelled) setBrand(FALLBACK); });
    return () => { cancelled = true; };
  }, []);

  useEffect(() => {
    if (!brand) return;
    document.title = brand.name || FALLBACK.name;
    const root = document.documentElement.style;
    const set = (names, value) => value && names.forEach((n) => root.setProperty(n, value));
    set(["--primary", "--ring", "--chart-1"], brand.primary);
    set(["--primary-foreground"], brand.primary_foreground);
    set(["--secondary", "--chart-2"], brand.secondary);
  }, [brand]);

  if (!brand) return null; // évite d'afficher un instant le nom d'une autre marque
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
};
